__turbopack_context__.v({
  "container": "ZrnMwq_container",
  "progressLoadingStyles": "ZrnMwq_progressLoadingStyles",
});
